import { render, staticRenderFns } from "./Clipper.vue?vue&type=template&id=e8c0bda4&lang=pug"
import script from "./Clipper.vue?vue&type=script&lang=js"
export * from "./Clipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports